import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../services/api";
import axiosPrivate from "../../services/axios/axiosPrivate";

export const createProfileData = createAsyncThunk('profileData/create',
    async ({id, payload}, { rejectWithValue }) => {
        try {
            const response = await axiosPrivate.post(api.support.submitProfileData(id), payload);
            return response.data;
        } catch (error) {
            return rejectWithValue(error?.response?.data?.message || "Unable to connect to server");
        }
    })

export const fetchProfileData = createAsyncThunk('profileData/fetch',
    async (id, { rejectWithValue }) => {
        try {
            const response = await axiosPrivate.get(api.support.getProfileData(id));
            return response.data.data;
        } catch (error) {
            return rejectWithValue(error?.response?.data?.message || "Unable to connect to server");
        }
    })

export const fetchProfileDiffData = createAsyncThunk('profileData/fetchDiff',
    async (id, { rejectWithValue }) => {
        try {
            const response = await axiosPrivate.get(api.support.getProfileDiffData(id));
            return response.data.data;
        } catch (error) {
            return rejectWithValue(error?.response?.data?.message || "Unable to connect to server");
        }
    })

const profileUpdateSupportSlice = createSlice({
    name: 'profileUpdate',
    initialState: {
        profileUpdate: [],
        profileDiffData: [],
        updateStatus: 'idle',
        getDataStatus: 'idle',
        getDiffDataStatus: 'idle',
        updateLoading: false,
        getDataLoading: false,
        getDiffDataLoading: false,
        updateError: null,
        getDataError: null,
        getDiffDataError: null
    },
    extraReducers: (builders) => {
        builders.
            addCase(createProfileData.pending,
                (state) => {
                    state.updateStatus = 'loading';
                    state.updateLoading = true;
                    state.updateError = null;
                })
            .addCase(createProfileData.fulfilled,
                (state, action) => {
                    state.updateStatus = 'succeeded';
                    state.updateLoading = false;
                })
            .addCase(createProfileData.rejected,
                (state, action) => {
                    state.updateStatus = 'failed';
                    state.updateLoading = false;
                    state.updateError = action.payload;
                })
            .addCase(fetchProfileData.pending,
                (state) => {
                    state.getDataStatus = 'loading';
                    state.getDataLoading = true;
                    state.getDataError = null;
                })
            .addCase(fetchProfileData.fulfilled,
                (state, action) => {
                    state.getDataStatus = 'succeeded';
                    state.getDataLoading = false;
                    state.profileUpdate = action.payload || [];
                })
            .addCase(fetchProfileData.rejected,
                (state, action) => {
                    state.getDataStatus = 'failed';
                    state.getDataLoading = false;
                    state.getDataError = action.payload;
                })
            .addCase(fetchProfileDiffData.pending,
                (state) => {
                    state.getDiffDataStatus = 'loading';
                    state.getDiffDataLoading = true;
                    state.getDiffDataError = null;
                })
            .addCase(fetchProfileDiffData.fulfilled,
                (state, action) => {
                    state.getDiffDataStatus = 'succeeded';
                    state.getDiffDataLoading = false;
                    state.profileDiffData = action.payload || [];
                })
            .addCase(fetchProfileDiffData.rejected,
                (state, action) => {
                    state.getDiffDataStatus = 'failed';
                    state.getDiffDataLoading = false;
                    state.getDiffDataError = action.payload;
                })
    }
})

export default profileUpdateSupportSlice.reducer;